import React from 'react';

var SvgSendMajor = function SvgSendMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.415.189a1 1 0 0 1 1.1-.046l15 9a1 1 0 0 1 0 1.714l-15 9a1 1 0 0 1-1.491-1.074l1.73-7.783h5.246a1 1 0 1 0 0-2h-5.247l-1.73-7.783a1 1 0 0 1 .393-1.028z"
  }));
};

export { SvgSendMajor as S };
